export const events = {
  PagesViewed: 'pages_viewed',
  PagesDocumentsUploadStarted: 'pages_documents_upload_started',
  PagesDocumentsUploaded: 'pages_documents_uploaded',
  PagesDocumentsReviewed: 'pages_documents_reviewed',
  PagesDocumentsPublished: 'pages_documents_published',
  PagesDocumentsPublishConfirmed: 'pages_documents_publish_confirmed',
}
